import { AzmoonMaharatDetail_Files_Interface } from "./AzmoonMaharatDetail_Files_Interface";

export interface AzmoonMaharatAnswer_Interface {
    id:number,
    customname:string,
    code:string,
    title:string,
    title2:string,
    file:Array<AzmoonMaharatDetail_Files_Interface>,
  }
  
  export function Empty_AzmoonMaharatAnswer_Interface():AzmoonMaharatAnswer_Interface{
    return{
      id:0,
      customname:'',
      code:'',
      title:'',
      title2:'',
      file:[],
    }
  }